import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm" style={{ color: "var(--brand-text-secondary)" }}>
        Se incarca...
      </div>
    );
  if (!user || user === false) return <Navigate to="/login" replace />;
  if (role && user.role !== role && !(role === "owner" && user.role === "admin")) {
    return <Navigate to="/" replace />;
  }
  return children;
}
